jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.testimonials').length ) {
        let $ = jQuery;
        $(".testimonials-slider").slick({
            arrows: false,
            dots: true,
            fade: true
        });
    }
});